import type { LucideIcon } from 'lucide-react'
import { cn } from '../../lib/utils'

/** 玻璃态统计卡 */
export function StatCard({ label, value, hint, icon: Icon, tone = 'default' }: {
  label: string
  value: string | number
  hint?: string
  icon?: LucideIcon
  tone?: 'default' | 'critical' | 'primary' | 'success' | 'warning'
}) {
  const toneCls = {
    default: 'text-muted-foreground',
    primary: 'text-primary',
    critical: 'text-critical',
    success: 'text-success',
    warning: 'text-warning',
  }[tone]
  const glowCls = tone === 'critical' ? 'glow-critical animate-emergency-pulse' : ''
  return (
    <div className={cn('panel-glass rounded-xl p-4', glowCls)}>
      <div className="mb-2.5 flex items-center justify-between">
        <span className="text-xs text-muted-foreground">{label}</span>
        {Icon && <Icon size={16} className={toneCls} />}
      </div>
      <div className="flex items-baseline justify-between gap-2">
        <strong className="font-mono text-2xl font-semibold tabular-nums text-foreground">{value}</strong>
        {hint && <span className={cn('text-[10px]', toneCls)}>{hint}</span>}
      </div>
    </div>
  )
}
